'use client';

import { FaqSection } from '@/components/sections/faq-section';
import { useTranslation } from '@/lib/i18n/context';

export function AcademyFaq() {
  const { t } = useTranslation();

  const items = [
    {
      question: t.academy['Why is AI taking over customer support?'],
      answer:
        t.academy[
          "It's not about taking over, it's about handling scale. AI can instantly resolve 50-80% of routine questions (refunds, status checks, FAQs) without making customers wait. This frees up humans to handle the complex, emotional, or high-stakes issues that actually require a human touch."
        ],
    },
    {
      question: t.academy['Why should I learn this now?'],
      answer:
        t.academy[
          "Because the industry is shifting. Support roles are moving from 'answering tickets' to 'managing AI agents' and 'designing conversation flows'. Learning these skills now positions you as an expert in the new era of support, rather than someone who just answers phones."
        ],
    },
    {
      question: t.academy['Will this take my job?'],
      answer:
        t.academy[
          "It will change your job. Low-level data entry and copy-pasting answers will disappear. But the demand for people who understand customer problems and can train AI to solve them is skyrocketing. You'll spend less time on repetitive tasks and more time on strategy, quality assurance, and complex problem-solving."
        ],
    },
    {
      question: t.academy['Are these courses free?'],
      answer:
        t.academy[
          'Yes. We believe the future of support should be accessible to everyone. The core curriculum at Open Academy is completely free. We want to empower the next generation of support leaders.'
        ],
    },
    {
      question: t.academy['Do I get a certificate upon completion?'],
      answer:
        t.academy[
          "While we don't issue formal certificates yet, our team is happy to endorse your new skills on LinkedIn or provide a reference via email upon successful completion of the advanced tracks."
        ],
    },
    {
      question: t.academy['Do I need technical skills to start?'],
      answer:
        t.academy[
          'No coding experience is required. Our courses are designed for support professionals, not software engineers. We focus on the practical application of AI tools, strategy, and workflow design using no-code interfaces.'
        ],
    },
    {
      question: t.academy['How often is the content updated?'],
      answer:
        t.academy[
          'AI moves fast, and so do we. We update our lessons monthly to include the latest developments in LLMs, new tooling features, and emerging best practices in the industry.'
        ],
    },
    {
      question: t.academy['Is there a community I can join?'],
      answer:
        t.academy[
          "Yes! When you enroll, you get access to our private Slack community of over 5,000 support leaders and AI enthusiasts. It's the perfect place to ask questions, share wins, and network."
        ],
    },
  ];

  return (
    <FaqSection
      title={t.academy['Frequently Asked Questions']}
      subtitle={t.academy['No fluff. Just straight answers.']}
      items={items}
    />
  );
}
